var events = {};

export function init() {
  window.cmsEventBus = {
    publish
  }
}

export function subscribe(eventName, eventHandler) {
  console.info("[info][cmsEventBus] - subscribe to " + eventName + " event");
  if (typeof events[eventName] === 'undefined') {
    events[eventName] = [];
  }

  events[eventName].push({
    eventHandler
  });
}

export function publish(eventName, eventParameters = null, error = null, success = null) {

  if (!events[eventName] || events[eventName].length === 0) {
    console.error(`[error][${eventName}] - évènement non souscrit`);
    return false;
  }

  events[eventName].forEach(eventObj => {
    let {eventHandler} = eventObj;

    eventHandler(eventParameters, error, success);
  });
}


// WEBPACK FOOTER //
// ./src/js/utils/eventBus.js